import { AppLinkTree } from "@megarax/links";
import tinycolor from "tinycolor2";

import { isAppTreeActive } from "./navHelpers";
import { navAccent, navIconBg } from "./navConstants";

export const getNavIconBackground = (accentColor: string): string =>
  tinycolor.mix(accentColor, "#ffffff", 88).toString();

export const getActiveAppTree = (
  linkTree: AppLinkTree[],
  pathname: string,
  searchParams: URLSearchParams,
): AppLinkTree | undefined =>
  linkTree.find((appTree) => isAppTreeActive(appTree, pathname, searchParams));

export const resolveNavAccentColors = (
  linkTree: AppLinkTree[],
  pathname: string,
  searchParams: URLSearchParams,
) => {
  const activeApp = getActiveAppTree(linkTree, pathname, searchParams);
  const accentColor = activeApp?.color ?? navAccent;
  const iconBackgroundColor = activeApp ? getNavIconBackground(activeApp.color) : navIconBg;

  return { activeApp, accentColor, iconBackgroundColor };
};
